import { matchPath } from 'react-router-dom'
import Routes, { IRoute } from '../components/Routes'
import { ILookupItem } from '../models/Feedback'
import { SelectItem } from '../models/SelectIem'

const getParentKey = (item) => {
  if (item.hasOwnProperty('idAwardIndustry')) {
    return item.idAwardIndustry
  } else if (item.hasOwnProperty('idRFAICM')) {
    return item.idRFAICM
  } else if (item.hasOwnProperty('idIM')) {
    return item.idIM
  } else if (item.hasOwnProperty('index')) {
    return item.index
  }
  return ''
}

export const buildSelectItem = (
  data,
  showDefault,
  parentKey = null
): SelectItem[] => {
  const result = data.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.name,
    parentkey: parentKey == null ? getParentKey(item) : parentKey,
  }))

  return showDefault ? [{ value: '', text: '[Choose one]' }, ...result] : result
}
export const buildAttributeSelectItem = (
  data,
  showDefault,
  parentKey = null
): SelectItem[] => {
  const result = data.map((item) => ({
    key: item.id,
    value: item.index,
    text: item.name,
    parentkey: parentKey == null ? getParentKey(item) : parentKey,
  }))

  return showDefault ? [{ value: '', text: '[Choose one]' }, ...result] : result
}

export const buildSelectItems = (data, showDefault): SelectItem[] => {
  const result = data.map((item) => ({
    key: item.key,
    value: item.value,
    text: item.text,
  }))
  return showDefault ? [{ value: '', text: '[Choose one]' }, ...result] : result
}

export const buildLookupSelectItems = (
  data: ILookupItem[],
  showDefault
): SelectItem[] => {
  const result = data.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.name,
  }))
  return showDefault ? [{ value: '', text: '[Choose one]' }, ...result] : result
}

export const buildCulturalSelectItem = (
  data,
  showDefault,
  culture,
  parentKey = null
): SelectItem[] => {
  const result = data.map((item) => ({
    key: item.id,
    value: item.index,
    text: item.name,
    parentkey: parentKey == null ? getParentKey(item) : parentKey,
  }))
  let defaultChoice = ''
  if (culture != null) {
    switch (culture) {
      case 'ar-SA':
        defaultChoice = 'اختاروا واحدة'
        break
      case 'en-US':
        defaultChoice = 'Choose one'
        break
      case 'fil-PH':
        defaultChoice = 'Pumili ng isa'
        break
      case 'de-DE':
        defaultChoice = 'Eine Option wählen'
        break
      case 'fr-FR':
        defaultChoice = 'Sélectionnez une option'
        break
      case 'es-ES':
        defaultChoice = 'Elija una'
        break
      case 'hi-IN':
        defaultChoice = 'एक विकल्प चुनें'
        break
      case 'id-ID':
        defaultChoice = 'Pilih satu'
        break
      case 'it-IT':
        defaultChoice = 'Scegliene uno'
        break
      case 'ja-JP':
        defaultChoice = 'ひとつを選択'
        break
      case 'ko-KR':
        defaultChoice = '하나를 선택하세요'
        break
      case 'pt-PT':
        defaultChoice = 'Escolha um'
        break
      case 'th-TH':
        defaultChoice = 'เลือก'
        break
      case 'vi-VN':
        defaultChoice = 'Chọn một'
        break

      case 'ne-NP':
        defaultChoice = 'एउटा रोज्नुहोस्'
        break
      case 'zh-Hans':
        defaultChoice = '选择一项'
        break
      case 'zh-Hant':
        defaultChoice = '選擇一項'
        break
      default:
        defaultChoice = 'Choose one'
        break
    }
  }
  return showDefault
    ? [{ value: '', text: '[' + defaultChoice + ']' }, ...result]
    : result
}

export const buildCulturalDropDownItem = (
  data,
  showDefault,
  culture,
  parentKey = null
): SelectItem[] => {
  const result = data.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.name,
    parentkey: parentKey == null ? getParentKey(item) : parentKey,
  }))
  let defaultChoice = ''
  if (culture != null) {
    switch (culture) {
      case 'ar-SA':
        defaultChoice = 'اختاروا واحدة'
        break
      case 'en-US':
        defaultChoice = 'Choose one'
        break
      case 'fil-PH':
        defaultChoice = 'Pumili ng isa'
        break
      case 'de-DE':
        defaultChoice = 'Eine Option wählen'
        break
      case 'fr-FR':
        defaultChoice = 'Sélectionnez une option'
        break
      case 'es-ES':
        defaultChoice = 'Elija una'
        break
      case 'hi-IN':
        defaultChoice = 'एक विकल्प चुनें'
        break
      case 'id-ID':
        defaultChoice = 'Pilih satu'
        break
      case 'it-IT':
        defaultChoice = 'Scegliene uno'
        break
      case 'ja-JP':
        defaultChoice = 'ひとつを選択'
        break
      case 'ko-KR':
        defaultChoice = '하나를 선택하세요'
        break
      case 'pt-PT':
        defaultChoice = 'Escolha um'
        break
      case 'th-TH':
        defaultChoice = 'เลือก'
        break
      case 'vi-VN':
        defaultChoice = 'Chọn một'
        break

      case 'ne-NP':
        defaultChoice = 'एउटा रोज्नुहोस्'
        break
      case 'zh-Hans':
        defaultChoice = '选择一项'
        break
      case 'zh-Hant':
        defaultChoice = '選擇一項'
        break
      default:
        defaultChoice = 'Choose one'
        break
    }
  }
  return showDefault
    ? [{ value: '', text: '[' + defaultChoice + ']' }, ...result]
    : result
}
export const isEmpty = (str: string) => {
  return !str || str.length === 0
}

export const findByText = (options: SelectItem[], text: string) => {
  if (options === null || options === undefined) {
    return ''
  }
  const selection = options.find(
    (item) => item.text.toLowerCase() === text.toLowerCase()
  )
  if (selection) {
    return selection.value
  }
  return ''
}

export const findById = (options: SelectItem[], id: string) => {
  if (options === undefined) {
    return ''
  }
  for (let i = 0; i < options.length; i++) {
    if (options[i].value === id) return options[i].text
  }
}

export const findByIndex = (options: SelectItem[], index: string) => {
  if (options === undefined) {
    return ''
  }
  for (let i = 0; i < options.length; i++) {
    if (options[i].value === index) return options[i].key
  }
}
export const findIndex = (options: SelectItem[], id: string) => {
  if (options === undefined) {
    return ''
  }
  for (let i = 0; i < options.length; i++) {
    if (options[i].value === id) return options[i].parentkey
  }
}

export const validateABN = (abn: string): boolean => {
  // The 11 digit ABN is structured as a 9 digit identifier with two leading check digits.
  // The leading check digits are derived using a modulus 89 (remainder after dividing by 89) calculation.
  // See https://abr.business.gov.au/HelpAbnFormat.aspx for validation rules.
  // if (abn === undefined) {
  //   return false
  // }
  if (abn === null || abn === undefined) {
    return
  }
  abn = abn.replace(/\s/g, '')
  let i = abn.length
  if (i === 11) {
    const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]
    // 1. Subtract 1 from left most digit...
    const d = parseInt(abn[0]) - 1 + abn.substr(1)
    let sum = 0
    // 2. Multiply digits by weighting factor, and add together
    while (i--) sum += parseInt(d[i]) * weights[i]
    // 3. Divide the sum by 89. No remainder means its valid!
    return sum % 89 === 0
  } else {
    return false
  }
}

export const range = (len: number) => {
  const arr = []
  for (let index = 0; index < len; index++) {
    arr.push(index)
  }
  return arr
}

export const onKeyPressHandler = (event) => {
  if (event.keyCode == 13) {
  }
}

export const isPathMatch = (path: string): IRoute | null => {
  for (let i = 0; i < Routes.length; i++) {
    const match = matchPath(path, Routes[i])
    if (match && match.isExact) {
      return Routes[i]
    }
  }
  return null
}
export const handleClickOutside = (e) => {
  e.preventDefault()
  return 'Changes you made may not be saved.'
}

export const validataUrl = (url: string) => {
  let valid = false
  if (url === null || url === undefined) {
    return false
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {
    valid = true
  } else if (url.includes('.fwo.gov.au')) {
    valid = true
  } else if (url.includes('.fairwork.gov.au')) {
    valid = true
  } else if (url.includes('.idc.hosts.devnetwork')) {
    valid = true
  } else if (url.includes('.idc.hosts.pprodnetwork')) {
    valid = true
  } else if (url.includes('.govcms.amazee.io')) {
    valid = true
  } else if (url.includes('/')) {
    valid = true
  }

  return valid
}
export const cleanupUrlEncoding = (url: string) => {
  let cleanedUrl = ''
  if (url === null || url === undefined) {
    return null
  }
  cleanedUrl = url
    .replace('SummaryURL', 'SummaryUrl')
    .replace('SourceURL', 'SourceUrl')
    .replaceAll('%3D', '=')
    .replaceAll('%3d', '=')
    .replaceAll('%26', '&')
    .replaceAll('%252f', '/')
    .replaceAll('%252F', '/')
    .replaceAll('%2520', ' ')
    .replaceAll('%253A', ':')
    .replaceAll('%7c', '|')
    .replaceAll('%7C', '|')
    .replaceAll('%3f', '?')
    .replaceAll('%3F', '?')
    .replaceAll('%5b', '[')
    .replaceAll('%5B', '[')
    .replaceAll('%5D', ']')
    .replaceAll('%5d', ']')
    .replaceAll('%3A', ':')
    .replaceAll('%3a', ':')
  return cleanedUrl
}

export const isURL = (url) => {
  if (url === null || url === undefined) {
    return false
  }

  const pattern = new RegExp(
    '((http|https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)'
  )
  return !!pattern.test(url)
}
